"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const ServiceImplBase_1 = require("./ServiceImplBase");
class ExternalContextMenuServiceImpl extends ServiceImplBase_1.ServiceImplBase {
    get serviceName() {
        return "external-context-menu-service" /* ExternalContextMenu */;
    }
    appendContextMenuAsync(sheetName, targetMenu, config) {
        const verb = api_internal_contract_js_1.VerbId.AppendExternalMenuItem;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'appendContextMenuAsync',
            [api_internal_contract_js_1.ParameterId.WorksheetName]: sheetName,
            [api_internal_contract_js_1.ParameterId.ExternalMenuItemDisplayName]: config.displayName,
        };
        return this.execute(verb, parameters).then((response) => {
            const newMenuItemId = response.result;
            return newMenuItemId;
        });
    }
    removeContextMenuAsync(sheetName, targetMenu, menuItemId) {
        const verb = api_internal_contract_js_1.VerbId.RemoveExternalMenuItem;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'removeContextMenuAsync',
            [api_internal_contract_js_1.ParameterId.WorksheetName]: sheetName,
            [api_internal_contract_js_1.ParameterId.ExternalMenuItemId]: menuItemId,
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    executeContextMenuAsync(sheetName, targetMenu, menuItemId) {
        const verb = api_internal_contract_js_1.VerbId.ExecuteExternalMenuItem;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'executeContextMenuAsync',
            [api_internal_contract_js_1.ParameterId.WorksheetName]: sheetName,
            [api_internal_contract_js_1.ParameterId.ExternalMenuItemId]: menuItemId,
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    renameContextMenuAsync(sheetName, targetMenu, menuHeader, menuDescription) {
        const verb = api_internal_contract_js_1.VerbId.RenameExternalMenu;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'renameContextMenuAsync',
            [api_internal_contract_js_1.ParameterId.WorksheetName]: sheetName,
            [api_internal_contract_js_1.ParameterId.ExternalMenuHeader]: menuHeader,
            [api_internal_contract_js_1.ParameterId.ExternalMenuDescription]: menuDescription,
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
}
exports.ExternalContextMenuServiceImpl = ExternalContextMenuServiceImpl;
//# sourceMappingURL=ExternalContextMenuServiceImpl.js.map